export const colors = {
  primary: "#6C63FF",
  dark: "#1A1A2E",
  surface: "#16213E",
  accent: "#E94560",
  text: "#EAEAEA",
  muted: "#A0A0B0",
  success: "#4CAF50",
  warning: "#FF9800",
  error: "#F44336",
  white: "#FFFFFF",
  black: "#000000",
} as const;
